export function getRootUrl (rootPath) {
  const rootUrl = {
    default: {
      name: 'Programas do Governo',
      path: '/programas-do-governo',
    },

    'manual-do-enem': {
      name: 'Enem',
      path: '/enem',
    },
  }

  return rootUrl[rootPath] || rootUrl.default
}

export function getUrls (activePageNames) {
  const others = ['enade', 'enare', 'encceja', 'pronatec', 'revalida', 'sisutec']

  const urls = {
    default: [
      {
        name: 'Simulador',
        path: '/programas-do-governo',
      },
      {
        name: 'Enem',
        active: activePageNames.includes('enem'),
        type: 'multiple',
        values: [
          {
            name: 'ENEM 2023 - Tudo o que você precisa saber',
            path: '/enem',
            targetBlank: false,
          },
          {
            name: 'Enem Digital',
            path: '/enem/enem-digital',
            targetBlank: false,
          },
          {
            name: 'Manual do Enem',
            path: '/enem/manual-do-enem',
            targetBlank: false,
          },
          {
            name: 'Gabarito',
            path: '/enem/gabarito',
            targetBlank: false,
          },
        ],
      },
      {
        name: 'Sisu',
        active: activePageNames.includes('sisu'),
        type: 'multiple',
        values: [
          {
            name: 'Guia completo do SISU',
            path: '/sisu',
            targetBlank: false,
          },
          {
            name: 'O que é o SISU',
            path: '/sisu/o-que-e-quem-pode#o-que-e',
            targetBlank: false,
          },
          {
            name: 'Quem pode participar do SISU',
            path: '/sisu/o-que-e-quem-pode#quem-pode',
            targetBlank: false,
          },
          {
            name: 'Como se inscrever no SISU',
            path: '/sisu/como-se-inscrever',
            targetBlank: false,
          },
          {
            name: 'Lista de espera do SISU',
            path: '/sisu/lista-de-espera',
            targetBlank: false,
          },
          {
            name: 'Universidades participantes',
            path: '/sisu/universidades-participantes',
            targetBlank: false,
          },
          {
            name: 'Notas de Corte SISU',
            path: '/sisu/notas-de-corte',
            targetBlank: false,
          },
        ],
      },
      {
        name: 'Prouni',
        active: activePageNames.includes('prouni'),
        type: 'multiple',
        values: [
          {
            name: 'Guia completo do Prouni',
            path: '/prouni',
            targetBlank: false,
          },
          {
            name: 'O que é o Prouni',
            path: '/prouni/o-que-e-quem-pode#o-que-e',
            targetBlank: false,
          },
          {
            name: 'Quem pode participar do Prouni',
            path: '/prouni/o-que-e-quem-pode#quem-pode',
            targetBlank: false,
          },
          {
            name: 'Como se inscrever no Prouni',
            path: '/prouni/como-se-inscrever',
            targetBlank: false,
          },
          {
            name: 'Documentos Necessários',
            path: '/prouni/documentos-necessarios',
            targetBlank: false,
          },
          {
            name: 'Lista de espera do Prouni',
            path: '/prouni/lista-de-espera',
            targetBlank: false,
          },
          {
            name: 'Universidades participantes',
            path: '/prouni/universidades-participantes',
            targetBlank: false,
          },
          {
            name: 'Notas de Corte do Prouni',
            path: '/prouni/notas-de-corte',
            targetBlank: false,
          },
        ],
      },
      {
        name: 'Fies',
        active: activePageNames.includes('fies'),
        type: 'multiple',
        values: [
          {
            name: 'Guia completo do FIES',
            path: '/fies',
            targetBlank: false,
          },
          {
            name: 'O que é o FIES',
            path: '/fies/o-que-e-quem-pode#o-que-e',
            targetBlank: false,
          },
          {
            name: 'Quem pode participar do FIES',
            path: '/fies/o-que-e-quem-pode#quem-pode',
            targetBlank: false,
          },
          {
            name: 'Como funciona o FIES',
            path: '/fies/como-funciona',
            targetBlank: false,
          },
          {
            name: 'Como se inscrever no FIES',
            path: '/fies/como-se-inscrever',
            targetBlank: false,
          },
          {
            name: 'Aditamento / Renovação FIES',
            path: '/fies/aditamento-renovacao',
            targetBlank: false,
          },
          {
            name: 'Simulador do FIES',
            path: '/fies/simulador',
            targetBlank: false,
          },
          {
            name: 'Notas de Corte FIES',
            path: '/fies/notas-de-corte',
            targetBlank: false,
          },
        ],
      },
      {
        name: 'CNU',
        active: activePageNames.includes('cnu'),
        type: 'single',
        path: '/concurso-nacional-unificado',
      },
      {
        name: 'Outros',
        active: others.some(el => activePageNames.includes(el)),
        type: 'multiple',
        values: [
          {
            name: 'Enade',
            path: '/enade',
            targetBlank: false,
          },
          {
            name: 'Enare',
            path: '/enare',
            targetBlank: false,
          },
          {
            name: 'Encceja',
            path: '/encceja',
            targetBlank: false,
          },
          {
            name: 'Pronatec',
            path: '/pronatec',
            targetBlank: false,
          },
          {
            name: 'Revalida',
            path: '/revalida',
            targetBlank: false,
          },
          {
            name: 'Sisutec',
            path: '/sisutec',
            targetBlank: false,
          },
        ],
      },
    ],

    'manual-do-enem': [
      {
        name: 'Manual',
        path: '/enem/manual-do-enem',
      },
      {
        name: 'Gabarito',
        path: '/enem/gabarito',
      },
    ],
  }

  return urls[activePageNames] || urls.default
}

export function getPageType (pathName) {
  const regex = /enem-[a-z0-9-]*/
  return pathName.match(regex) ? 'manual-do-enem' : pathName
}
